// if (!customElements.get("cart-drawer")) {
//   customElements.define(
//     "cart-drawer",
//     class CartDrawer extends Drawer {
//       constructor() {
//         super();
//       }

//       show(opener) {
//         super.show(opener);

//         // 由于购物车的Dom内容会被替换，所以需要重新获取
//         const recommendationByHistory = this.querySelector(
//           "recommendation-by-history",
//         );
//         if (recommendationByHistory) recommendationByHistory.showContent();
//       }

//       hide() {
//         super.hide();

//         const recommendationByHistory = this.querySelector(
//           "recommendation-by-history",
//         );
//         if (recommendationByHistory) recommendationByHistory.abortFetch();
//       }
//     },
//   );
// }

if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);

        // 购物车打开时隐藏 Tidio，防止覆盖 Checkout
        document.documentElement.classList.add("cart-drawer-open");

        // 由于购物车 DOM 内容会被替换，所以需要重新获取
        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );

        if (recommendationByHistory) {
          recommendationByHistory.showContent();
        }
      }

      hide() {
        super.hide();

        // 购物车关闭后恢复 Tidio
        document.documentElement.classList.remove("cart-drawer-open");

        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );

        if (recommendationByHistory) {
          recommendationByHistory.abortFetch();
        }
      }
    },
  );
}